const columnHeader = "dibcne7yvx";
const sortableColumnHeaderChevron = "dibsx7fho8";
const sortableColumnHeader = "dibsod3etj";

export { columnHeader, sortableColumnHeader, sortableColumnHeaderChevron };
import "./column.style.linaria.module.css";
//# sourceMappingURL=column.style.js.map
